import { format } from 'date-fns';

import { UTCDate } from '@date-fns/utc';

const formatDateToEU = (date: number | string) => {
  return format(new UTCDate(date), 'dd.MM.yyyy');
};

export default formatDateToEU;
